import React from "react";
import { Row, Col } from "react-bootstrap";

import { Form, Button, TextArea, Label } from "./Contact.styles";
import { TextField } from "../../Shared/FormHelpers";
import Loader from "../../Shared/Loader";

const ContactForm = ({ name, onSubmit, bind, credits, loading }) => {
  return (
    <Col md={5}>
      <Form onSubmit={onSubmit}>
        <Row>
          <Col md={6}>
            <p style={{ float: "left" }}>
              Contact: {`${name ? `${name.fname} ${name.lname}` : "Applicant"}`}
            </p>
          </Col>
          <Col md={6}>
            <p style={{ float: "right" }}> {credits} contact credits remaining </p>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <TextField
              styles={{ height: 35 }}
              title="Name"
              placeholder="John Doe"
              {...bind.bindName}
            />
          </Col>
          <Col md={6}>
            <TextField
              title="Company"
              styles={{ height: 35 }}
              placeholder="Company A"
              {...bind.bindCompany}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Label>Message</Label>
            <TextArea
              componentClass="textarea"
              placeholder="Message to Applicant"
              {...bind.bindMessage}
            />
          </Col>
        </Row>
        <TextField
          title="Job Title"
          styles={{ height: 35 }}
          placeholder="Job Title"
          {...bind.bindJobTitle}
        />
        <Row>
          <Col md={12}>
            <Label>Job Description</Label>
            <TextArea
              componentClass="textarea"
              placeholder="Job Descriptions"
              {...bind.bindJobDescription}
            />
          </Col>
        </Row>
        <Row>
          <Col md={4} mdOffset={8}>
            <Button type="submit" disabled={loading}>
              {loading ? (
                <Loader width={25} height={25} show={loading} />
              ) : (
                "Send"
              )}
            </Button>
          </Col>
        </Row>
      </Form>
    </Col>
  );
};

export default ContactForm;
